<template>
<div>
  <loading :active="loadingIsCompleted"> </loading>
  <dashboard-layout :active="1" :container="true">
    <toster />
    <div class="row">
      <div class="col-xl-6 col-xxl-12 col-lg-12 col-xxl-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Relatório da Conta</h4>
            <span>Atualizado à <span>10</span> minutos atrás</span>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-xl col-lg col-md col-sm-auto col-6">
                <p class="mb-0">Total de Clientes</p>
                <h6>{{dataDashboard.totalClients}} <strong class="text-success">R$ {{dataDashboard.totalMoney}}</strong></h6>
              </div>
              <div class="col-xl col-lg col-md col-sm-auto col-6">
                <p class="mb-0">Treinos Hoje</p>
                <h6>{{dataDashboard.totalTrainingsToday}}</h6>
              </div>
              <div class="col-xl col-lg col-md col-sm-auto col-6">
                <p class="mb-0">Perfil</p>
                <h6>{{dataDashboard.profile.role}}</h6>
              </div>
              <div class="col-xl col-lg col-md col-sm-auto col-6">
                <p class="mb-0">BOT</p>
                <h6><strong class="text-danger">Não Conectado!</strong></h6>
                <!-- <h6><strong class="text-success">Conectado!</strong></h6> -->
              </div>
               <div class="col-xl col-lg col-md col-sm-auto col-6">
                <p class="mb-0">Data de Vencimento</p>
                <h6>{{formatDate(dataDashboard.profile.dateExpire)}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-xxl-12 col-lg-12 col-xxl-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Relatório do Site</h4>
            <span>Atualizado à <span>10</span> minutos atrás</span>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-xl col-lg col-md col-sm-auto col-6">
                <p class="mb-0">Visualizações</p>
                <h6>0</h6>
              </div>
              <div class="col-xl col-lg col-md col-sm-auto col-6">
                <p class="mb-0">Entrou em Contato</p>
                <h6>0</h6>
              </div>
              <div class="col-xl col-lg col-md col-sm-auto col-6">
                <p class="mb-0">Tempo médio</p>
                <h6>0 minutos</h6>
              </div>
              <div class="col-xl col-lg col-md col-sm-auto col-6">
                <p class="mb-0">Online no Momento</p>
                <h6>0</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-12 col-xxl-6">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Treinos Hoje ({{new Date().getDate()}}/{{new Date().getMonth() + 1}})</h4>
                <abbr title="Caso você não marque a presença, será contabilizado falta!"><i class="fa fa-info-circle"></i></abbr>
              </div>
              <perfect-scrollbar class="card-body trade-history">
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <thead>
                      <tr>
                        <th scope="col">Nome</th>
                        <th scope="col">Whatsapp</th>
                        <th scope="col">Treino</th>
                        <th scope="col">Compareceu</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="workout in dataDashboard.trainingsToday" :key="workout.id">
                        <td><strong>{{workout.client_name}}</strong></td>
                        <td><strong><a target="_blank" :href="'https://wa.me/' + workout.client_whatsapp">{{workout.client_whatsapp}}</a></strong></td>
                        <td><button @click="setDataModalTemp(JSON.parse(workout.exercises))" v-b-modal.modal-1 class="btn"><i class="fa fa-search-plus"></i></button></td>
                        <td>
                           <label class="toggle">
                            <input
                              class="toggle-checkbox"
                              type="checkbox"
                              :checked="workout.presenceToday"
                              @click="markPresenceOrNot(workout)"
                            />
                            <span class="toggle-switch"></span>
                          </label>

                          <label style="margin-right: 5px" v-show="workout.presenceToday == true"><i class="fa fa-check"></i> Sim</label>
                          <label style="margin-right: 5px" v-show="workout.presenceToday == false"><i class="fa fa-close"></i> Não</label></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </perfect-scrollbar>
            </div>
          </div>
        </div>
      </div>

      <b-modal id="modal-1" title="Treinos">
        <div
            class="card col-xl-5"
            style="margin-right: 10px; display: inline-block; background-color: #ededed;"
            v-for="exercicio in modalDataExercises"
            :key="exercicio"
          >
            <div class="card-header" style="background-color: #ededed">
              <label>Exercicio {{ exercicio.id }}</label>
            </div>
            <div class="card-body" >
              <div class="form-row">
                <div class="form-group col-xl-12">
                  <div class="media align-items-center mb-3">
                    <div class="media-body">
                      <p>{{exercicio.nome}}</p>
                      <p>{{exercicio.descricao}}</p>
                      <button class="btn btn-dark" :disabled="!exercicio.video"><a target="_blank" :href="exercicio.video">Ver Video </a></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </b-modal>

      <div class="col-xl-6 col-lg-6 col-md-12 col-xxl-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">BOT {{dataDashboard.profile.name}}</h4>
          </div>
          <perfect-scrollbar class="card-body trade-history">
            <div class="total-balance">
              <h3 v-if="message.color == 'red'" class="text">{{message.msg}}</h3>
              <h3 v-if="message.color == 'green'" class="text-success">{{message.msg}}</h3>
              <h3 v-if="message.color == 'orange'" class="text-primary">{{message.msg}}</h3>


              <h6>Status do BOT</h6>
              <br>
              <button v-if="botConnected == true" type="submit" @click="desconectar" name="submit" class="btn btn-danger">
                  Desligar BOT
                </button>
            </div>
            <div class="center">
              <hr>
              <div v-if="botConnected == false" class="btn-group btn-block mt-3" style="display: flex;flex-direction: row;justify-content: center;align-items: center;">
                <div v-show="ligarBot == false">
                  <h6> Abra seu whatsapp e scaneie esse QRCODE </h6>
                  <br />
                  <img width="280px" :src="this.qrcode" />
                  <br />
                  <hr>
                  <b-progress :value="contador" max="100" show-value class="mb-3"></b-progress>
                </div>
                <div v-show="ligarBot == true">
                  <h6> Para ligar seu BOT clique no botão </h6>
                  <button @click="startBot" type="submit" name="submit" class="btn btn-success">
                    Ligar BOT
                  </button>
                </div>
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </div> </div>
  </dashboard-layout>
</div>
</template>

<script>
import DashboardLayout from "../../components/Layouts/DashboardLayout.vue";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import Toster from "../../components/Tradio/Toster.vue";
import api from "../../services/funcoes-service";
import Loading from "../../components/Layouts/Loading.vue";
import moment from 'moment'
export default {
  components: {
    DashboardLayout,
    PerfectScrollbar,
    Toster,
    Loading
  },
  data() {
    return {
      sliderValue: 0,
      dataDashboard: { profile : {}},
      loadingIsCompleted: true,
      modalDataExercises: [],
      ligarBot: true,
      botConnected: false,
      qrcode: '',
      message: {
        msg: 'DESCONECTADO!',
        color: 'red'
      },
      contador: 0,
    };
  },
  mounted() {
    this.getDataDashboard();
  },
  methods: {
    onChange(e) {
      // console.log(e.target.value);
      this.sliderValue = e.target.value;
    },

    async getDataDashboard(ondeVeio = 'index') {
      try {
        const datas = await api.get(`/dashboard`);
        console.log(datas);
        if(datas.data.error == 1) return this.$toast.error(datas.data.message);
        this.dataDashboard = datas.data;
        if(ondeVeio == 'index'){
          // this.checkBot();
        }

        this.loadingIsCompleted = false
      } catch (error) {
        console.log(error)
        return this.$toast.error('Problema ao carregar dashboard!');
      }
    },

    setDataModalTemp(exercises){
      this.modalDataExercises = exercises;
    },

    async markPresenceOrNot(client){
      try {
        let presence = client.presenceToday == false ? true : false
        const update = await api.post('/dashboard/training/history', {presence: presence, client_id: client.client_id})
        if(update.data.error == 1) return this.$toast.error(update.data.message);

        this.$toast.success(update.data.message);
        this.getDataDashboard('presence');
      } catch (error) {
        this.$toast.error("Problema ao alterar presença!")
      }
    },

    async startBot() {
      try {
        console.log('start bot')
        const datas = await api.post(`/bot/create/session/a${this.dataDashboard.profile.id}b${this.dataDashboard.profile.name.replace(' ', '-')}c`, {});
        console.log(datas)
        if(datas.data.error == 1) return this.$toast.error(datas.data.data.message);
        console.log(datas)
        return this.geraQrCode()

      } catch (error) {
        console.log(error)
        return this.$toast.error('Problema ao carregar dashboard!');
      }
    },

    async geraQrCode() {
      try{
        const datas = await api.post(`/bot/a${this.dataDashboard.profile.id}b${this.dataDashboard.profile.name.replace(' ', '-')}c/start`, {})
        console.log(datas)
        console.log(datas)

        if(datas.data.error == 1) return this.$toast.error(datas.data.message)
        if(datas.data.status == 'CONNECTED') {
          this.message.msg = 'CONECTADO!'
          this.message.color = 'green'

          return this.$toast.success('Seu bot já está conectado!')
        }
        console.log(datas.data)
        this.message.msg = 'INICIANDO...'
        this.$toast.success('Aguarde... Iniciando whatsapp!')
        
        console.log(datas)
        if(datas.data.data.base64){
          this.qrcode = datas.data.data.base64
          this.ligarBot = false;
          this.message.msg = 'AGUARDANDO SCANEAR...'
          this.message.color = 'orange'
          // return this.checkQrCode()
        }
        // return this.checkQrCode()
      }catch(error){
        console.log(error)
      }
    },

    async checkQrCode() {
      try {
        const datas = await api.get(`/bot/a${this.dataDashboard.profile.id}b${this.dataDashboard.profile.name.replace(' ', '-')}c/check-qrcode`)
        if(datas.data.error == 1) return this.$toast.error(datas.data.message)

        if(datas.data.data.status == 'CONNECTED'){
          this.botConnected = true
          this.message.msg = 'CONECTADO!'
          this.message.color = 'green'
          return this.$toast.success('Seu bot está conectado!')
        }
        this.ligarBot = false;
        if(datas.data.data.status == 'INITIALIZING' || datas.data.data.status == 'QRCODE'){
        if (datas.data.data.status == 'INITIALIZING') this.message.msg = 'GERANDO QR CODE...'
        if (datas.data.data.status == 'QRCODE'){
          this.message.msg = 'AGUARDANDO SCANEAR...'
          this.message.color = 'orange'
        }

        this.qrcode = datas.data.data.qrcode
        await this.sleep(1000)
        if(this.contador === 100) this.contador = 0
        this.contador = this.contador + 10
        return this.checkQrCode()
        }

      } catch (error) {
        console.log(error)
      }
    },

    async checkBot(){
      const datas = await api.get(`/bot/a${this.dataDashboard.profile.id}b${this.dataDashboard.profile.name.replace(' ', '-')}c/check-session`)
      console.log(datas)
      if(datas.data.error == 1) return this.$toast.error(datas.data.message)

      if(datas.data.data.status == true){
        this.botConnected = true
        this.message.msg = 'CONECTADO!'
        this.message.color = 'green'
        return this.$toast.success('Seu bot está conectado!')
      }
        return this.$toast.danger('Seu bot não está conectado!')
    },

    async desconectar(){
      try {
        const datas = await api.post(`/bot/a${this.dataDashboard.profile.id}b${this.dataDashboard.profile.name.replace(' ', '-')}c/close-session`, {})
        if(datas.data.error == 1) return this.$toast.error(datas.data.message)
        this.botConnected = false
        this.message.msg = 'DESCONECTADO!'
        this.message.color = 'red'
        return this.$toast.success('Seu bot foi desconectado!')
      } catch (error) {
        console.log(error)
      }
    },

    formatDate(date){
      const newdate = `${moment(date)
      .utc()
      .format("DD/MM/YYYY")}`;
      this.date_end = newdate;
      return newdate;
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
   }
  },
};
</script>
